













import { defineComponent, computed } from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';
import thailandProvinces from '@/gql/thailandProvinces.gql';

const CommonProvinceSelector = defineComponent({
  setup(props: any) {
    const { result, loading } = useQuery(thailandProvinces);
    const items = useResult(result, null, (data) => data?.thailandProvinces);
    const _value = computed(() => props.value);
    const itemsId = computed(() => {
      if (!items.value) return [undefined];
      const temp: string[] = [];
      items.value.forEach((item: any) => {
        temp.push(item.id);
      });
      return temp;
    });
    const itemsName = computed(() => {
      if (!items.value) return [undefined];
      const temp: string[] = [];
      items.value.forEach((item: any) => {
        temp.push(item.name);
      });
      return temp;
    });

    const amphur = computed(() => {
      if (!items.value) return [undefined];
      // eslint-disable-next-line
      const temp = items.value.find((item: any) => item.id === props.value);
      return temp.amphurs;
    });

    return {
      loading,
      itemsId,
      itemsDisplay: itemsName,
      amphur,
      _value,
    };
  },
  props: {
    label: {
      type: String,
      default() { return 'จังหวัด'; },
    },
    value: {
      type: String,
      default() { return ''; },
    },
  },
});

export default CommonProvinceSelector;
